import { tokens } from '@env0/ui-theme';

/** Spacing is not on the theme: CSS reads `var(--spacing-…)` and its siblings, JS reads `tokens.spacing`. */
export const sharedPrimitives = {
  zIndex: tokens.zIndex,
  shadows: tokens.shadows
} as const;

export type DesignPrimitives = typeof sharedPrimitives;

/**
 * antd's own ladder, unchanged in 5.29, which the app renders on today. Figma's numbers are MUI's (md 900)
 * and its descriptions mark them PROVISIONAL, so these hold until design decides
 * (APO-455 D4) — adopting md 900 moves the mobile boundary for 45 `isMobile` reads, a behaviour
 * change rather than a repaint.
 */
export const ANTD_BREAKPOINTS = {
  xs: '480px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1600px'
} as const;

export type Breakpoints = typeof ANTD_BREAKPOINTS;

export type LayoutDimensions = Record<keyof typeof tokens.layout, string>;
